<template>
    <div class="">
        <div class="kris-component-head">
            <h1 v-if="project">{{project.label}}</h1>
        </div>
        <h2>Статус участия в проекте:</h2>
        <span style="font-size:15px;" v-if="status == 'member'"><strong>Участник</strong></span>
        <span style="font-size:15px;" v-else-if="status == 'candidate'"><strong>Кандидат</strong></span>
        <span v-else>Отсутствует</span>
        <span v-if="profile"> ({{profile}})</span>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: "Status",
    data() {
        return {
        }
    },
    computed:{
        ...mapState({
            statuses: 'statuses',
            status: 'status',
            project: 'currentProject',
            profile: 'profile'
        })
    },
    created() {
    },
    methods: {
    },
}
</script>

<style scoped>

</style>
